import React from 'react';
import { FORM_GROUP_VARIANTS } from "../../../helpers/formGroupVariants";
import { FormGroup } from 'arag-ui-lib';
import QuestionEditActions from "../QuestionEditActions";




const TextInputType = (props) => {
    const {
        question,
        value,
        formData,
        isPlain,
        application,
        hasInlineElements,
        textHandler,
        mapEditingQuestionOrFieldToEditingSetting,
        approvalOptions,
        openEditQuestionAnswerModal,
        checkIfPlainEditable,
        checkIfQuestionHasPendingChanges,
        openHistoryModal,
        isLabelClickable,
    } = props;
    const variant = isPlain ? FORM_GROUP_VARIANTS.PLAIN : FORM_GROUP_VARIANTS.TEXT;
    return (
        <FormGroup
            variant={variant}
            labelSize={"col-sm-3"}
            inputSize={"col-sm-6"}
            label={question.name}
            inputProps={{
                id: `question-id-${question.id}`,
                name: question.machineName,
                label: isPlain ? value : '',
                value: isPlain ? '' : value,
                onChange: (evt) => textHandler(question.id, evt.target.value),
                required: question.isRequired,
                autoComplete: 'off'
            }}
            hasInlineElements={hasInlineElements}
            inlineGroupElements={
                hasInlineElements 
                ? 
                    <div className={"col-sm-3"}>
                        <QuestionEditActions
                            checkIfPlainEditable={checkIfPlainEditable(question, question.machineName)}
                            question={question}
                            mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                            approvalOptions={approvalOptions}
                            onClick={() => openEditQuestionAnswerModal({ questionAnswerForEdit: question, questionAnswer: formData[question.id] })}
                            hasPendingChanges={checkIfQuestionHasPendingChanges( question.id, application )}
                        />
                    </div>
                :
                    null
            }
            onLabelClick={ isLabelClickable ? () => openHistoryModal(question) : undefined }
            formGroupTestId={`policy-application-${question.machineName}`}
        />
    );
};

export default TextInputType;
